import React, { useState } from 'react';
import axios from 'axios';
import Button from '../ui/Button';
import { Lock, Eye, EyeOff, Check } from 'lucide-react';

const ChangePasswordSection = () => {
  const [formData, setFormData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [show, setShow] = useState({ current: false, next: false, confirm: false });

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

  const handle = (k, v) => { setFormData(prev => ({ ...prev, [k]: v })); setError(''); setSuccess(''); };

  const validate = () => {
    if (!formData.currentPassword) return setError('Current password is required'), false;
    if (!formData.newPassword) return setError('New password is required'), false;
    if (formData.newPassword.length < 6) return setError('New password must be at least 6 characters'), false;
    if (formData.newPassword === formData.currentPassword) return setError('New password must be different'), false;
    if (formData.newPassword !== formData.confirmPassword) return setError('Password confirmation does not match'), false;
    return true;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_BASE_URL}/api/user/change-password`, {
        current_password: formData.currentPassword,
        new_password: formData.newPassword
      }, { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } });
      setSuccess('Password changed successfully!');
      setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  const EyeBtn = ({ field }) => (
    <button type="button" onClick={() => setShow(prev => ({ ...prev, [field]: !prev[field] }))} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-text-muted)' }}>
      {show[field] ? <EyeOff size={16} /> : <Eye size={16} />}
    </button>
  );

  return (
    <div style={{ maxWidth: 520 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
        <Lock size={18} color="#6b7280" />
        <h2 style={{ margin: 0, fontSize: 18 }}>Change Password</h2>
      </div>
      <form onSubmit={submit}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Current Password</label>
          <div style={{ position: 'relative' }}>
            <input type={show.current ? 'text' : 'password'} value={formData.currentPassword} onChange={(e) => handle('currentPassword', e.target.value)} required style={{ width: '100%', padding: '10px 40px 10px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 6, fontSize: 14 }} />
            <EyeBtn field="current" />
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6 }}>New Password</label>
          <div style={{ position: 'relative' }}>
            <input type={show.next ? 'text' : 'password'} value={formData.newPassword} onChange={(e) => handle('newPassword', e.target.value)} required style={{ width: '100%', padding: '10px 40px 10px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 6, fontSize: 14 }} />
            <EyeBtn field="next" />
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Confirm New Password</label>
          <div style={{ position: 'relative' }}>
            <input type={show.confirm ? 'text' : 'password'} value={formData.confirmPassword} onChange={(e) => handle('confirmPassword', e.target.value)} required style={{ width: '100%', padding: '10px 40px 10px 12px', border: '1px solid var(--color-border-strong)', borderRadius: 6, fontSize: 14 }} />
            <EyeBtn field="confirm" />
          </div>
        </div>
        {error && (<div style={{ background: 'var(--color-danger-bg)', border: '1px solid var(--color-danger-border)', color: 'var(--color-danger-hover)', padding: 12, borderRadius: 6, fontSize: 14 }}>{error}</div>)}
        {success && (<div style={{ background: 'var(--color-success-bg)', border: '1px solid var(--color-success-border)', color: 'var(--color-success-fg)', padding: 12, borderRadius: 6, fontSize: 14, display: 'flex', gap: 8, alignItems: 'center' }}><Check size={16} /> {success}</div>)}
        <Button type="submit" loading={loading} disabled={loading} size="sm" icon={<Lock size={14} /> }>{loading ? 'Changing...' : 'Change Password'}</Button>
      </form>
    </div>
  );
};

export default ChangePasswordSection;